import React, { memo } from 'react';
import withDefaultTheme from '../../../hocs/withDefaultTheme.js';
import useTab from '../hooks/useTab.js';
import TabPanel from './TabPanel.js';

var Tab = function Tab(_ref) {
  var children = _ref.children,
    name = _ref.name,
    label = _ref.label,
    order = _ref.order,
    onClick = _ref.onClick;
  var _useTab = useTab({
      name: name,
      label: label,
      order: order,
      onClick: onClick
    }),
    isHidden = _useTab.isHidden;
  // TODO fix memoized render and actually use it ( it needs to watch user props also )
  return /*#__PURE__*/React.createElement(TabPanel, {
    name: name,
    isHidden: isHidden
  }, children);
};
var _TabSection = withDefaultTheme(/*#__PURE__*/memo(Tab));

export default _TabSection;
